module.exports = __webpack_public_path__ + "img/img40.25e3a2c6.svg";